import Community from "./community";
import './footer.css'
const Footer = () => {
  return (
    <>
      
      <footer></footer>
    </>
  );
};
export default Footer;
